import React, { Component } from "react";


class CircularProgressBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const isMobile = this.props.isMobile

    const demoPreview = this.props.demoPreview
    // Size of the enclosing square
    const sqSize = demoPreview ? 70:isMobile?85:150;
    // SVG centers the stroke width on the radius, subtract out so circle fits in square
    const radius = (sqSize - this.props.strokeWidth) / 2;
    // Enclose cicle in a circumscribing square
    const viewBox = `0 0 ${sqSize} ${sqSize}`;
    // Arc length at 100% coverage is the circle circumference
    const dashArray = radius * Math.PI * 2;
    // Scale 100% coverage overlay with the actual percent
    const dashOffset = dashArray - (dashArray * this.props.percentage) / 100;

    const { themeSettings } = this.props;

    return (
      <svg
        width={sqSize}
        height={sqSize}
        viewBox={viewBox}
      >
        <circle
          className="trivia-timer-survey-circle-background"
          cx={sqSize / 2}
          cy={sqSize / 2}
          r={radius}
          strokeWidth={`${this.props.strokeWidth}px`}
          style={{}}
        />
        <circle
          className="trivia-timer-survey-circle-progress"
          cx={sqSize / 2}
          cy={sqSize / 2}
          r={radius}
          strokeWidth={`${this.props.strokeWidth}px`}
          // Start progress marker at 12 O'Clock
          transform={`rotate(-90 ${sqSize / 2} ${sqSize /
            2})`}
          style={{
            strokeDasharray: dashArray,
            strokeDashoffset: dashOffset,
            stroke: themeSettings ? themeSettings.quizTextColor : "blue",
          }}
        />
        <text
          className="trivia-timer-survey-circle-text"
          x="50%"
          y="50%"
          dy="0.3em"
          textAnchor="middle"
          style={{
            fill: themeSettings ? themeSettings.quizTextColor : "blue",
            fontSize: demoPreview ?"1.6em": !isMobile?"4em": "2.5em"
          }}
        >
          {this.props.secondsRemaining}
        </text>
      </svg>
    );
  }
}

CircularProgressBar.defaultProps = {
  percentage: 25,
  strokeWidth: 4,
};

export default class QuizTimer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      totalSeconds: props.timerLimit,
      secondsRemaining: props.timerLimit,
    };

    this.timer = null;
  }

  componentDidMount() {
    this.timer = setInterval(this.updateTimer, 1000);
  }

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.currentQuestion.question_id) !==
      JSON.stringify(nextProps.currentQuestion.question_id)
    ) {
      this.setState(
        {
          secondsRemaining: this.props.timerLimit,
        },
        () => {
          //  console.log("calling from here");
          //this.timer = setInterval(this.updateTimer, 1000);
        }
      );
    }
  }

  updateTimer = () => {
    const { secondsRemaining,totalSeconds } = this.state;
    if (secondsRemaining == 0) {
      this.stopTimer();
    } else {
      if(secondsRemaining==1){
        if(this.props.lastQuestionRestrict){
          this.props.lastQuestionRestrict()
        }
      }
      this.setState({ secondsRemaining: secondsRemaining - 1 });
      
    }
  };

  stopTimer = () => {
    console.log("Stopping timer");
    clearInterval(this.timer);
    this.props.onTimeEnd();
  };

  render() {
    const { totalSeconds, secondsRemaining } = this.state;

    const percentage = (secondsRemaining / totalSeconds) * 100;

    return (
      <div className="text-center my-4">
        <CircularProgressBar
          percentage={percentage}
          secondsRemaining={secondsRemaining}
          themeSettings={this.props.themeSettings}
          isMobile={this.props.isMobile}
          demoPreview={this.props.demoPreview}
        />
      </div>
    );
  }
}
